import * as Constants from "_core/configs/Constants";
const dbName = Constants.APP_KEY + "mediaCache";
const storeName = "media";

// IndexedDBを開く
export function openDB() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, 1);
        request.onerror = () => reject(request.error);
        request.onsuccess = () => resolve(request.result);
        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName, { keyPath: 'key' });
            }
        };
    });
}

// データを保存する
export  async function SetItem(key, data) {
    const db = await openDB();
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);
    store.put({ key, data });
    return new Promise((resolve) => {
        transaction.oncomplete = () => resolve();
        transaction.onerror = () => console.error("Transaction failed:", transaction.error);
    });
}

// データを取得する
export async function GetItem(key) {
    const db = await openDB();
    const transaction = db.transaction(storeName, "readonly");
    const store = transaction.objectStore(storeName);
    const request = store.get(key);
    return new Promise((resolve) => {
        request.onsuccess = () => {
            resolve(request.result ? request.result.data : null);
        };
        request.onerror = () => console.error("Request failed:", request.error);
    });
}